import React, { Component } from "react";
import { Glyphicon, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";
import NumberFormat from "react-number-format";

import Button from "../../../../components/common/button/Button";
import Steps from "../../../../components/common/steps/Steps";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { formatDateSmallWithoutTimezone } from "../../../../utils/dates";

import { Mixpanel } from "../../../../actions/mixpanel.actions";

import styles from "./ProjectReview.scss";
import saveIcon from "../../../../assets/images/save-icon.svg";
import editIcon from "../../../../assets/images/edit-icon-blue.svg";

class ProjectReview extends Component {
  getSuffix(type) {
    if (!type) return "";
    switch (type.toUpperCase()) {
      case "HOURLY":
        return "/hour";
      case "DAILY":
        return "/day";
      case "WEEKLY":
        return "/week";
      case "MONTHLY":
        return "/month";
      default:
        return "";
    }
  }

  render() {
    const {
      handleClick,
      invalid,
      submitting,
      pristine,
      project,
      skills
    } = this.props;

    var category = 0;
    var addCategory = true;
    const skillsMapper = (skill, index) => {
      if (skill.description.category_id !== category) {
        category = skill.description.category_id;
        var skillCategory = (
          <h3 className={styles.subSectionHeader + " " + styles.categoryTitle}>
            {_.get(skills[category - 1], "name")}
          </h3>
        );
        addCategory = true;
      } else {
        addCategory = false;
      }

      return (
        <div key={index}>
          <span>{addCategory ? skillCategory : ""}</span>
          <li>{skill.description.name}</li>
        </div>
      );
    };

    const mustSkillsList =
      !_.isEmpty(project.must_skills) && project.must_skills.map(skillsMapper);

    const mustSkillsListComponent = (
      <ul className={styles.list}>{mustSkillsList}</ul>
    );

    const niceSkillsList =
      !_.isEmpty(project.nice_skills) && project.nice_skills.map(skillsMapper);

    const niceSkillsListComponent = (
      <ul className={styles.list}>{niceSkillsList}</ul>
    );

    const NA = <span className={styles.naStyle}>N/A</span>;
    const bullet = <span className={styles.bullet}>&#9679;</span>;

    const formattedBudgetStart =
      formatDateSmallWithoutTimezone(project.budget_run_start) == "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(project.budget_run_start);

    const formattedBudgetEnd =
      formatDateSmallWithoutTimezone(project.budget_run_end) == "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(project.budget_run_end);

    let city = project.state
      ? `${project.city}, ${project.state}`
      : project.city;

    //remove 'USA' if the city string includes it
    if (project.city && project.city.includes(", USA")) {
      city = project.city.replace(", USA", "");
    }

    const dateField = () => {
      if (project.budget_run_start && project.budget_run_end) {
        return `${formattedBudgetStart} - ${formattedBudgetEnd}`;
      } else if (!project.budget_run_start && !project.budget_run_end) {
        return "Timing TBD";
      } else {
        if (project.budget_run_start) {
          return "Start Date: " + formattedBudgetStart;
        } else if (project.budget_run_end) {
          return "Project Due: " + formattedBudgetEnd;
        }
      }
    };

    let budgetRate = parseFloat(project.budget_rate_value);

    const budgetRateValue =
      _.get(project, "budget_type.value") === "Negotiable" ? (
        "Request from Member"
      ) : (
        <NumberFormat
          value={budgetRate}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
          decimalScale={2}
        />
      );

    return (
      <div className={styles.reviewContainer}>
        <ScrollToTopOnMount />

        <div className={styles.steps}>
          <div className={styles.header}>
            <Steps steps={this.props.steps} activeStep={4} track={true} />
          </div>
        </div>
        <div className={styles.secondHeader}>
          This is how your project will look to Second Shift Members who match
          your “must-have” skill criteria.
        </div>

        <div className={styles.projectReview}>
          <Row>
            <Col>
              <h1> {project.title} </h1>
              <div className={styles.titleDescription}>
                Company: {_.get(project, "user.profile.company.name")}
              </div>
              &nbsp;
            </Col>
          </Row>

          <Row>
            <div className={styles.divider} />
            <div className={styles.divider} />
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Summary</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {_.get(project, "category.name")}
              {bullet}
              {city}
              {bullet}
              {dateField()}
              {bullet}
              {_.get(project, "budget_type.value") === "Negotiable" ? (
                "Request Fee from Member"
              ) : (
                <NumberFormat
                  value={budgetRate}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  decimalScale={2}
                  suffix={this.getSuffix(_.get(project, "budget_type.value"))}
                />
              )}
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Job Description</h2>
            <Link
              to={`/company/project/id/${project.id}/details`}
              onClick={() =>
                Mixpanel.track("Project Creation - Review - Edit Description")
              }
            >
              <Glyphicon glyph="pencil" /> Edit
            </Link>
            &nbsp;
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <h3 className={styles.subSectionHeader}>Overview</h3>
              <div>{ReactHtmlParser(project.overview)}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>
                Responsibilities + Deliverables
              </h3>
              <div>{ReactHtmlParser(project.responsibilities)}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Office location</h3>
              <div>{city}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Work from</h3>
              <div>
                {_.get(project, "work_type.value") === "Both"
                  ? "Remote and On Site"
                  : _.get(project, "work_type.value")}
              </div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Job Type</h3>
              <div>
                <p>{_.get(project, "job_type.value")}</p>
              </div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Company Budget</h3>
              <div>
                <p>{_.get(project, "company_budget.value")}</p>
              </div>
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Budget</h2>
            <Link
              to={`/company/project/id/${project.id}/budget`}
              onClick={() =>
                Mixpanel.track("Project Creation - Review - Edit Budget")
              }
            >
              <Glyphicon glyph="pencil" /> Edit
            </Link>
          </Row>
          <Row className={styles.whiteSection}>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Rate type</h3>
              <p>{_.get(project, "budget_type.value")}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Rate</h3>
              <p>{budgetRateValue}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Hours per Week</h3>
              <p>
                {project.budget_rate_period ? project.budget_rate_period : NA}
              </p>
            </Col>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Project Run</h2>
            <Link
              to={`/company/project/id/${project.id}/budget`}
              onClick={() =>
                Mixpanel.track("Project Creation - Review - Edit Project Run")
              }
            >
              <Glyphicon glyph="pencil" /> Edit
            </Link>
          </Row>
          <Row className={styles.whiteSection}>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Start</h3>
              <p>{formattedBudgetStart}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>End</h3>
              <p>{formattedBudgetEnd}</p>
            </Col>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Skills</h2>
            <Link
              to={`/company/project/id/${project.id}/skills`}
              onClick={() =>
                Mixpanel.track("Project Creation - Review - Edit Skills")
              }
            >
              <Glyphicon glyph="pencil" /> Edit
            </Link>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <div className={styles.skillsListContainer}>
                <h3 className={styles.subSectionHeader}>Must have skills</h3>
                {_.isEmpty(mustSkillsList) ? NA : mustSkillsListComponent}
              </div>

              <div className={styles.divider} />

              <div className={styles.skillsListContainer}>
                <h3 className={styles.subSectionHeader}>Nice-to-Have Skills</h3>
                {_.isEmpty(niceSkillsList) ? NA : niceSkillsListComponent}
              </div>
            </div>
          </Row>

          <Row>
            &nbsp;
            <div className={styles.divider} />
            <div className={styles.divider} />
            &nbsp;
          </Row>

          <Row className={classnames(styles.whiteSection, styles.footer)}>
            <Col md={6} xs={12}>
              <div className={styles.footerTitle}>
                Ready to Meet Your Matches?
              </div>
              <div className={styles.footerText}>
                Make sure all the information in this Project is correct. By
                clicking Submit, you affirm that you are permitted to publicly
                post a project on behalf of your company.
              </div>
            </Col>
            <Col md={1} xs={12} />
            <Col md={5} xs={12} className={styles.footerActions}>
              <Button
                id="company-project-review-submit-for-approval"
                label="Submit for Approval"
                onClick={handleClick}
                isDisabled={invalid || submitting || pristine}
              />

              <div className={styles.linksFlex}>
                <Link
                  to={`/company/project/id/${project.id}/details`}
                  onClick={() =>
                    Mixpanel.track(
                      "Project Creation - Review - Edit Job Details"
                    )
                  }
                >
                  <img src={editIcon} className={styles.horLinkIcon} />
                  Edit Job Details
                </Link>
                <span className={styles.verticalBar}> </span>
                <Link
                  to={this.props.draftUrl}
                  onClick={() =>
                    Mixpanel.track("Project Creation - Review - Save For Later")
                  }
                >
                  <img
                    src={saveIcon}
                    width="14"
                    className={styles.horLinkIcon}
                  />
                  Save For Later
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ProjectReview;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/ProjectReview.js